import {Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import { PatientDataProvider } from 'src/app/providers/patient-data/patient-data';
import {SipProvider} from '../../../providers/sip/sip';
import {ViewController} from '../../../providers/view-controller.service';
import { Subscription } from 'rxjs';

declare let cordova;

@Component({
  selector: 'app-page-call-view',
  templateUrl: 'call-view.html',
  styleUrls: ['./call-view.scss']
})
export class CallViewPageComponent implements OnInit, OnDestroy {

  private subscrbe1:Subscription;
  private subscrbe2:Subscription;
  private subscrbe3:Subscription;
  private subscrbe4:Subscription;
  private subscrbe5:Subscription;
  private subscrbe6:Subscription;

  showAdressData = false;

  @Input() isVideo;
  @Input() callName = 'Unbekannt';

  @ViewChild('peerAudio') peerAudio: any;
  @ViewChild('peerVideo') peerVideo: any;
  @ViewChild('myVideo') myVideo: any;


  constructor(public viewCtrl: ViewController, private sipProvider: SipProvider, public patientDataProvider:PatientDataProvider) {
  }

  ngOnDestroy() {
    this.subscrbe1.unsubscribe();
    this.subscrbe2.unsubscribe();
    this.subscrbe3.unsubscribe();
    this.subscrbe4.unsubscribe();
    this.subscrbe5.unsubscribe();
    this.subscrbe6.unsubscribe();
  }

  ngOnInit() {
    const callViewonSelfStream = (stream: any) => {
      this.myVideo.nativeElement.muted = 'muted';
      this.myVideo.nativeElement.srcObject = stream;
      this.myVideo.nativeElement.play();
    };

    this.subscrbe1 = this.sipProvider.events.subscribe('onSelfStream', callViewonSelfStream);

    const callViewonRemoteStream = (stream: any) => {
      this.peerAudio.nativeElement.srcObject = stream;
      this.peerAudio.nativeElement.play();

      if (typeof cordova !== 'undefined') {
        if (cordova && cordova.plugins && cordova.plugins.iosrtc) {
          cordova.plugins.iosrtc.observeVideo(this.peerVideo.nativeElement);
        }
      }

      this.peerVideo.nativeElement.muted = 'muted';
      this.peerVideo.nativeElement.srcObject = stream;
      this.peerVideo.nativeElement.setAttribute('autoplay', 'autoplay');
      this.peerVideo.nativeElement.setAttribute('playsinline', 'playsinline');
      this.peerVideo.nativeElement.play();

      if (typeof cordova !== 'undefined') {
        if (cordova && cordova.plugins && cordova.plugins.iosrtc) {
          cordova.plugins.iosrtc.selectAudioOutput('speaker');
          cordova.plugins.iosrtc.refreshVideos();
        }
      }
    };

    this.subscrbe2 = this.sipProvider.events.subscribe('onRemoteStream', callViewonRemoteStream);

    const callViewonTrack = (trackEv: any) => {      
      if((this.sipProvider.session._request.from._uri._user === "NOVO" || (this.sipProvider.session._request.from._uri._user.startsWith("00") || this.sipProvider.session._request.from._uri._user.startsWith("+")))
        && this.sipProvider.session.direction === "incoming") {
        this.isVideo = false;

        if(this.patientDataProvider.activePatientData) {
          this.showAdressData = true;
        }
      }

      if (trackEv.track.kind === 'video') {
        if(!this.showAdressData) {
          this.isVideo = true;
        }
        
        if (typeof cordova !== 'undefined') {
          if (cordova && cordova.plugins && cordova.plugins.iosrtc) {
            cordova.plugins.iosrtc.observeVideo(this.peerVideo.nativeElement);
          }
        }

        this.peerVideo.nativeElement.muted = 'muted';
        this.peerVideo.nativeElement.srcObject = (trackEv.streams[0]);
        this.peerVideo.nativeElement.setAttribute('autoplay', 'autoplay');
        this.peerVideo.nativeElement.setAttribute('playsinline', 'playsinline');
        this.peerVideo.nativeElement.play();
        if (typeof cordova !== 'undefined') {
          if (cordova && cordova.plugins && cordova.plugins.iosrtc) {
            cordova.plugins.iosrtc.selectAudioOutput('speaker');
            cordova.plugins.iosrtc.refreshVideos();
          }
        }
      }
      console.log(trackEv.track.kind);
    };

    this.subscrbe3 = this.sipProvider.events.subscribe('onTrack', callViewonTrack);

    const callViewonFailed = (e: any) => {
      this.viewCtrl.dismiss(e).catch((error) => {
        console.log(error);
      });
    };

    this.subscrbe4 = this.sipProvider.events.subscribe('onFailed', callViewonFailed);

    const callViewonEnded = (e: any) => {
      this.viewCtrl.dismiss(e).catch((error) => {
        console.log(error);
      });
      if (typeof cordova !== 'undefined') {
        if (cordova && cordova.plugins && cordova.plugins.iosrtc) {
          cordova.plugins.iosrtc.refreshVideos();
          cordova.plugins.iosrtc.observeVideo(this.peerVideo.nativeElement);
        }
      }
    };

    this.subscrbe5 = this.sipProvider.events.subscribe('onEnded', callViewonEnded);

    const callViewonUpdateUI = (session: any) => {
      if (!session) {
        this.viewCtrl.dismiss().catch((error) => {
          console.log(error);
        });
      }
    };

    this.subscrbe6 = this.sipProvider.events.subscribe('onUpdateUI', callViewonUpdateUI);
  }

  hangup() {
    this.sipProvider.hangUp();
  }

}
